import { useAppConfigContext } from '@/context/AppContext';
import useScreen from '@/hooks/useScreen';
import React from 'react';

const defaultContentFlags = {
  app: true,
  mobileWeb: true,
  desktopWeb: true,
  isFlutterClient: false,
};

const withContentFlags = (Component: React.ComponentType<any>) => {
  const WrappedComponent = (props: any) => {
    const { contentFlags, ...componentProps } = props;
    const { isDesktop, isMobile, isTablet } = useScreen();
    const { state: appConfig } = useAppConfigContext();
    const { app, mobileWeb, desktopWeb } = contentFlags || defaultContentFlags;
    const { isFlutterClient } = appConfig;
    if ((!isFlutterClient && (mobileWeb || desktopWeb)) || (app && isFlutterClient)) {
      return (
        <Component
          isDesktop={isDesktop}
          isMobile={isMobile}
          isTablet={isTablet}
          app={app}
          {...componentProps}
        />
      );
    } else {
      return null;
    }
  };

  WrappedComponent.displayName = `withContentFlags(${
    Component.displayName || Component.name || 'Component'
  })`;

  return WrappedComponent;
};

export default withContentFlags;
